exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-tab{color:rgba(0,0,0,.64)!important}.v-tab--disabled{opacity:.2!important}.v-tabs__div:has(.v-tabs__item--active){color:#eaeaff!important}", ""]);

// exports
